import { cn } from "@/utils/cn";
import { THEMES, useTheme } from "./themeStore";

/**
 * Color-scheme picker for the workspace rail. Three text options (light / dark
 * / beige); the current theme is inked, the others stay quiet. No icons — the
 * theme itself applies site-wide via the token overrides in index.css.
 */
export const ThemeToggle = ({ className }: { className?: string }) => {
  const { theme, setTheme } = useTheme();

  return (
    <div
      role="radiogroup"
      aria-label="Color scheme"
      className={cn("flex items-baseline gap-3 items-center", className)}
    >
      {THEMES.map((name) => {
        const selected = theme === name;
        return (
          <button
            key={name}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => setTheme(name)}
            className={cn(
              "font-ui transition-all focus-visible:outline-none focus-visible:text-zinc-900",
              selected ? "text-zinc-800" : "text-zinc-400 hover:text-zinc-800",
            )}
          >
            {name}
          </button>
        );
      })}
    </div>
  );
};
